import { jsxs as n, jsx as t } from "react/jsx-runtime";
const a = ({ className: e, width: r = "24", height: o = "24", color: i }) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    width: r,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: { color: i },
    fill: "none",
    children: [
      /* @__PURE__ */ t("path", { d: "M19.595 8.184a8.5 8.5 0 1 1-4.923-4.253", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ t("animateTransform", { attributeType: "xml", attributeName: "transform", type: "rotate", from: "0 0 0", to: "360 0 0", dur: "1s", additive: "sum", repeatCount: "indefinite" })
    ]
  }
);
export {
  a as default
};
